import RetencionService from '@/services/retencion.services'
export const namespaced = true

export const actions = {
  fetchRetencion(context, payload) {
    let params = 'params' in payload ? payload.params : null
    return RetencionService.getRetencion(payload.jwt, params)
  },
  addRetencion(context, payload) {
    return RetencionService.postRetencion(payload.jwt, payload.body)
  },
  editRetencion(context, payload) {
    return RetencionService.putRetencion(payload.jwt, payload.body, payload.id)
  },
  deleteRetencion(context, payload) {
    return RetencionService.deleteRetencion(payload.jwt, payload.body, payload.id)
  },
}
